(() => {
  if (window.FEROBRILL_SAVED_PIECES_ACTIVE) return;
  const root = document.getElementById('fb-saved-pieces-config');
  if (!root) return;

  const config = JSON.parse(root.textContent);
  window.FEROBRILL_SAVED_PIECES_ACTIVE = true;

  const login = document.getElementById('fb-saved-pieces-login');
  const signIn = login?.querySelector('[data-fb-saved-signin]');
  const pendingTitle = login?.querySelector('[data-fb-pending-title]');
  const LOCAL_KEY = 'ferobrill:saved-pieces';
  const HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;

  function readLocal() {
    try {
      const value = JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]');
      return Array.isArray(value) ? value.filter(handle => HANDLE.test(handle)) : [];
    } catch (_) {
      return [];
    }
  }

  function writeLocal(handles) {
    try {
      localStorage.setItem(LOCAL_KEY, JSON.stringify([...new Set(handles)]));
    } catch (_) {}
  }

  function setButtonState(button, saved) {
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    const label = button.querySelector('[data-fb-saved-label]');
    if (label) label.textContent = saved ? (config.text?.saved || 'Piece saved') : (config.text?.save_piece || 'Save Piece');
  }

  function showStatus(message) {
    let status = document.getElementById('fb-saved-pieces-status');

    if (!status) {
      status = document.createElement('div');
      status.id = 'fb-saved-pieces-status';
      status.className = 'fb-sp-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.appendChild(status);
    }

    status.textContent = message;
    clearTimeout(status._timer);
    status._timer = setTimeout(() => {
      status.textContent = '';
    }, 1800);
  }

  const STATE_URL='/apps/ferobrill-saved-pieces/state';
  const TOGGLE_URL='/apps/ferobrill-saved-pieces/toggle';

  function syncButtons(handles=readLocal()) {
    const saved=new Set(handles);
    document.querySelectorAll('[data-fb-wishlist]').forEach(button=>setButtonState(button,saved.has(button.dataset.fbWishlist)));
  }

  async function loadState(){
    if(!config.loggedIn){syncButtons();return;}
    try{
      const r=await fetch(STATE_URL,{credentials:'same-origin',headers:{Accept:'application/json'}});
      const b=await r.json();
      if(!r.ok||!b.ok||!Array.isArray(b.handles))throw 0;
      const h=b.handles.filter(x=>HANDLE.test(x));
      writeLocal(h);syncButtons(h);
    }catch(_){syncButtons();}
  }

  async function toggleRemote(target,handle){
    target.setAttribute('aria-busy','true');
    try{
      const r=await fetch(TOGGLE_URL,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({handle})});
      const b=await r.json().catch(()=>({}));
      if(!r.ok||!b.ok||!Array.isArray(b.handles))throw new Error(b.error||config.text?.error||'Saved Pieces is temporarily unavailable.');
      const h=b.handles.filter(x=>HANDLE.test(x));
      writeLocal(h);syncButtons(h);
      showStatus(b.saved?(config.text?.saved_notice||'Piece saved'):(config.text?.removed_notice||'Piece removed'));
    }catch(e){showStatus(e instanceof Error?e.message:(config.text?.error||'Please try again.'))}
    finally{target.removeAttribute('aria-busy')}
  }

  function savedPiecesDestination(handle) {
    const url = new URL(config.accountPage, window.location.origin);
    const query = url.search;
    url.search = '';
    url.pathname = url.pathname.replace(/\/$/, '') + '/save/' + encodeURIComponent(handle);
    url.search = query;
    return url.href;
  }

  document.addEventListener('click', event => {
    const close = event.target.closest?.('[data-fb-saved-close]');
    if (close) {
      event.preventDefault();
      close.closest('dialog')?.close();
      return;
    }

    const target = event.target.closest?.('[data-fb-wishlist]');
    if (!target) return;

    const handle = target.dataset.fbWishlist;
    if (!HANDLE.test(handle || '')) return;

    event.preventDefault();
    event.stopPropagation();

    const destination = savedPiecesDestination(handle);

    if (!config.loggedIn) {
      if (pendingTitle) pendingTitle.textContent = target.dataset.fbProductTitle || config.text?.login_note || '';
      if (signIn) signIn.href = destination;
      if (login && typeof login.showModal === 'function' && !login.open) login.showModal();
      return;
    }

    toggleRemote(target, handle);
  }, true);

  login?.addEventListener('click', event => {
    if (event.target !== login) return;
    const rect = login.getBoundingClientRect();
    if (
      event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom
    ) {
      login.close();
    }
  });

  loadState();
})();